require("./safetysecurity.scss");
